// 処理全体をひとつの初期化関数にまとめる
const initMemberControl = () => {
    const tableWrap = document.getElementById('jcc-table-wrap');
    const tbody = document.getElementById('jcc-member-tbody');

    // 会員管理ページ以外では何もしない
    if (!tableWrap || !tbody) return;

    // 会員管理ページなのに設定がない時だけ異常扱い
    if (typeof window.jccMemberConfig === 'undefined') {
        console.error('jccMemberConfig が未定義です。PHP側の出力またはスクリプト依存関係を確認してください。');
        return;
    }

    // if (typeof window.jccMemberConfig === 'undefined') {
    //     console.warn("⚠️ 【警告】 window.jccMemberConfig が見つかりません。処理を中断します。PHP側の出力タイミングを確認してください。");
    //     return;
    // }

    const config = window.jccMemberConfig;

    let currentPage = 1;
    let CURRENT_PAYMENT_TYPE = config.paymentType;
    const CURRENT_FISCAL_YEAR = config.fiscalYear;
    let currentTotalPages = 1; // ★ これを追加（現在の絞り込み条件での全ページ数を保持）

    // const tableWrap = document.getElementById('jcc-table-wrap');
    // const tbody = document.getElementById('jcc-member-tbody');
    const pagContainer = document.getElementById('jcc-pagination');
    const totalCountLabel = document.getElementById('jcc-total-count');
    const btnToggleFilter = document.getElementById('btn-toggle-filter');
    const filterAccordion = document.getElementById('jcc-filter-accordion');
    const filterModal = document.getElementById('jcc-filter-modal');
    const btnCloseFilterModal = document.getElementById('btn-close-filter-modal');
    const btnReset = document.getElementById('btn-reset');
    let lastFilterTrigger = null;

    // ★ PC判定用ヘルパー関数
    const isPC = () => window.innerWidth >= 768;

    const setFilterModalState = (isOpen) => {
        if (btnToggleFilter) {
            btnToggleFilter.classList.toggle('is-open', isOpen);
            btnToggleFilter.setAttribute('aria-expanded', String(isOpen));
        }

        if (filterModal) {
            filterModal.classList.toggle('show', isOpen);
            // PCの時は常に表示させるため、aria-hidden を false に保つ
            filterModal.setAttribute('aria-hidden', isPC() ? 'false' : String(!isOpen));
        }
    };

    const openFilterModal = () => {
        if (!filterModal || isPC()) return; // ★ PC時はモーダルとして開かない
        lastFilterTrigger = document.activeElement;
        setFilterModalState(true);
        window.requestAnimationFrame(() => {
            document.getElementById('filter-search')?.focus();
        });
    };

    const closeFilterModal = () => {
        if (!filterModal || isPC()) return; // ★ PC時は閉じない
        const wasOpen = filterModal.classList.contains('show');
        setFilterModalState(false);

        if (wasOpen && lastFilterTrigger && typeof lastFilterTrigger.focus === 'function') {
            lastFilterTrigger.focus();
        }
    };

    // ★ 画面幅の切り替えを監視し、PCとSPでモーダルの状態を安全にリセットする
    const mediaQuery = window.matchMedia('(min-width: 768px)');
    const handleMediaQueryChange = (e) => {
        if (e.matches) {
            // PC幅になったら、モーダルの状態クラスを解除（表示はCSSで行うため）
            filterModal?.classList.remove('show');
            filterModal?.setAttribute('aria-hidden', 'false');
            btnToggleFilter?.classList.remove('is-open');
            btnToggleFilter?.setAttribute('aria-expanded', 'false');
        } else {
            // SP幅になったら、デフォルトの非表示（隠れた状態）にリセット
            filterModal?.classList.remove('show');
            filterModal?.setAttribute('aria-hidden', 'true');
        }
    };
    mediaQuery.addEventListener('change', handleMediaQueryChange);
    handleMediaQueryChange(mediaQuery); // 初期ロード時にも実行

    if (btnToggleFilter && filterModal) {
        btnToggleFilter.addEventListener('click', () => {
            if (filterModal.classList.contains('show')) {
                closeFilterModal();
            } else {
                openFilterModal();
            }
        });
    }

    if (btnCloseFilterModal) {
        btnCloseFilterModal.addEventListener('click', closeFilterModal);
    }

    if (filterModal) {
        filterModal.addEventListener('click', (e) => {
            if (e.target === filterModal) closeFilterModal();
        });
    }

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && filterModal?.classList.contains('show')) {
            closeFilterModal();
        }
    });

    const escapeHTML = (str) => {
        if (!str) return '';
        return String(str).replace(/[&<>'"]/g, match => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
        })[match]);
    };

    const rebuildFilterSelect = (selectId, items, defaultLabel) => {
        const select = document.getElementById(selectId);
        if (!select) return false;

        const previousValue = select.value;
        select.innerHTML = '';

        const defaultOption = document.createElement('option');
        defaultOption.value = '';
        defaultOption.textContent = defaultLabel;
        select.appendChild(defaultOption);

        items.forEach(item => {
            const option = document.createElement('option');
            option.value = item;
            option.textContent = item;
            select.appendChild(option);
        });

        const exists = items.includes(previousValue);
        select.value = exists ? previousValue : '';
        return previousValue !== select.value;
    };

    const refreshFilterOptions = async () => {
        try {
            const response = await fetch(config.apiBaseUrl + 'get-filter-options', {
                headers: {
                    'X-WP-Nonce': config.restNonce
                }
            });
            const result = await response.json();

            if (!response.ok || !result.success) {
                throw new Error(result.message || '絞り込み候補の取得に失敗しました。');
            }

            rebuildFilterSelect('filter-group', result.data.groups || [], 'すべての班');
            rebuildFilterSelect('filter-position', result.data.positions || [], 'すべての役職');
            updateActiveFiltersUI();
        } catch (error) {
            console.error(error);
        }
    };

    const syncPaymentTypeUI = (paymentType, { clearFilters = false } = {}) => {
        CURRENT_PAYMENT_TYPE = paymentType === 'monthly' ? 'monthly' : 'yearly';

        const hiddenPType = document.getElementById('filter-ptype');
        const pStatusSelect = document.getElementById('filter-pstatus');
        const pMonthlyWrap  = document.getElementById('filter-monthly-wrap');
        const pMonthSelect  = document.getElementById('filter-pmonth');
        const mStatusSelect = document.getElementById('filter-mstatus');
        const yearlyWrap    = document.getElementById('edit-yearly-wrap');
        const monthlyWrap   = document.getElementById('edit-monthly-wrap');
        const currentLabel  = document.getElementById('jcc-current-payment-type-label');

        if (hiddenPType) hiddenPType.value = CURRENT_PAYMENT_TYPE;
        if (pStatusSelect) pStatusSelect.style.display = CURRENT_PAYMENT_TYPE === 'yearly' ? 'block' : 'none';
        if (pMonthlyWrap)  pMonthlyWrap.style.display  = CURRENT_PAYMENT_TYPE === 'monthly' ? 'flex' : 'none';
        if (yearlyWrap)    yearlyWrap.style.display    = CURRENT_PAYMENT_TYPE === 'yearly' ? 'block' : 'none';
        if (monthlyWrap)   monthlyWrap.style.display   = CURRENT_PAYMENT_TYPE === 'monthly' ? 'block' : 'none';
        if (currentLabel)  currentLabel.textContent    = `${CURRENT_PAYMENT_TYPE === 'monthly' ? '月会費' : '年会費'}`;

        document.querySelectorAll('input[name="jcc-payment-setting"]').forEach(radio => {
            radio.checked = radio.value === CURRENT_PAYMENT_TYPE;
        });

        if (clearFilters) {
            if (pStatusSelect) pStatusSelect.value = '';
            if (pMonthSelect)  pMonthSelect.value  = '';
            if (mStatusSelect) mStatusSelect.value = '';
        }
    };

    const fetchMembers = async (page = 1) => {
        currentPage = page;
        tableWrap.classList.add('is-loading');

        const params = new URLSearchParams({
            page: page,
            search: document.getElementById('filter-search').value,
            group: document.getElementById('filter-group').value,
            position: document.getElementById('filter-position').value,
            ptype: CURRENT_PAYMENT_TYPE,
            pstatus: CURRENT_PAYMENT_TYPE === 'yearly'
                ? document.getElementById('filter-pstatus').value
                : document.getElementById('filter-mstatus').value,
            pmonth: CURRENT_PAYMENT_TYPE === 'monthly'
                ? document.getElementById('filter-pmonth').value
                : '',
            sort: document.getElementById('filter-sort').value
        });

        try {
            const response = await fetch(
                config.apiBaseUrl + 'get-members?' + params.toString(),
                {
                    headers: {
                        'X-WP-Nonce': config.restNonce
                    }
                }
            );
            const result = await response.json();

            if (response.ok && result.success) {
                currentTotalPages = result.pagination.total_pages; // ★ これを追加！
                renderTable(result.data);
                renderPagination(result.pagination.total_pages, result.pagination.current_page);
                totalCountLabel.textContent = `(${result.pagination.total_items})`;
                updateActiveFiltersUI();
            } else {
                tbody.innerHTML = '<tr><td colspan="7" style="padding: 20px; text-align:center;">データの取得に失敗しました。</td></tr>';
            }
        } catch (error) {
            console.error(error);
            tbody.innerHTML = '<tr><td colspan="7" style="padding: 20px; text-align:center;">通信エラーが発生しました。</td></tr>';
        } finally {
            tableWrap.classList.remove('is-loading');
        }
    };

    const updateActiveFiltersUI = () => {
        const container = document.getElementById('jcc-active-filters');
        if (!container) return;

        container.innerHTML = '';

        let paymentLabel = '';
        if (CURRENT_PAYMENT_TYPE === 'yearly') {
            const s = document.getElementById('filter-pstatus');
            if (s.value !== '') paymentLabel = `年会費: ${s.options[s.selectedIndex].text}`;
        } else {
            const m = document.getElementById('filter-pmonth');
            const s = document.getElementById('filter-mstatus');
            if (m.value !== '') {
                paymentLabel = `月会費: ${m.value}月(${s.options[s.selectedIndex].text})`;
            } else if (s.value !== '') {
                paymentLabel = `月会費: ${s.options[s.selectedIndex].text}`;
            }
        }

        const filters = [
            { id: 'filter-search',   val: document.getElementById('filter-search').value,   label: document.getElementById('filter-search').value },
            { id: 'filter-group',    val: document.getElementById('filter-group').value,    label: document.getElementById('filter-group').value },
            { id: 'filter-position', val: document.getElementById('filter-position').value, label: document.getElementById('filter-position').value },
            { id: 'filter-payment',  val: paymentLabel,                                      label: paymentLabel }
        ];

        let activeCount = 0;
        filters.forEach(f => {
            if (f.val !== '' && f.val !== null) {
                activeCount++;
                const badge = document.createElement('div');
                badge.className = 'jcc-filter-badge';
                badge.innerHTML = `${f.label} <button type="button" data-id="${f.id}">×</button>`;
                badge.querySelector('button').onclick = () => {
                    if (f.id === 'filter-payment') {
                        document.getElementById('filter-pstatus').value = '';
                        document.getElementById('filter-pmonth').value = '';
                        document.getElementById('filter-mstatus').value = '';
                    } else {
                        document.getElementById(f.id).value = '';
                    }
                    fetchMembers(1);
                };
                container.appendChild(badge);
            }
        });

        container.classList.toggle('is-visible', activeCount > 0);

        // ▼ 修正ポイント：ソートが「標準（default）」以外に変更されているかも判定に含める
        const sortVal = document.getElementById('filter-sort').value;
        const isSortActive = (sortVal !== 'default');

        // 絞り込み条件がある、またはソートが変更されている場合はリセットボタンを有効化
        const shouldEnableReset = (activeCount > 0 || isSortActive);

        if (btnReset) {
            // btnReset.disabled = !shouldEnableReset;
            // btnReset.setAttribute('aria-disabled', String(!shouldEnableReset));
            // btnReset.classList.toggle('is-disabled', !shouldEnableReset);
            // ★ disabledの切り替えだけでなく、displayプロパティで表示・非表示を制御する
            btnReset.style.display = shouldEnableReset ? 'inline-flex' : 'none';
            btnReset.disabled = !shouldEnableReset;
            btnReset.setAttribute('aria-disabled', String(!shouldEnableReset));
        }
        // ★ 親要素（.jcc-filter-status-row）自体の表示・非表示を制御
        const statusRow = document.querySelector('.jcc-filter-status-row');
        if (statusRow) {
            statusRow.style.display = shouldEnableReset ? 'flex' : 'none';
        }
    };

    const renderTable = (members) => {
        tbody.innerHTML = '';
        if (members.length === 0) {
            tbody.innerHTML = '<tr><td colspan="7" style="padding: 30px; text-align: center; color: #666;">該当する会員はいません。</td></tr>';
            return;
        }

        members.forEach(member => {
            let paidClass, paidText;

            if (member.payment_type === 'monthly') {
                let months = [];
                try { months = JSON.parse(member.paid_months || '[]'); } catch (e) { months = []; }
                paidClass = months.length > 0 ? 'paid' : 'unpaid';
                paidText = `<span style="font-size: 13px;">${months.length}ヶ月</span>`;
            } else {
                paidClass = String(member.is_paid) === '1' ? 'paid' : 'unpaid';
                paidText  = String(member.is_paid) === '1'
                    ? '<span class="icon-check-bold"></span>'
                    : '<span class="icon-x-bold"></span>';
            }

            const tr = document.createElement('tr');
            tr.className = 'jcc-member-row';
            tr.dataset.id = member.id;
            tr.dataset.name = member.name;
            tr.dataset.kana = member.name_kana;
            tr.dataset.group = member.group_name;
            tr.dataset.position = member.position;
            tr.dataset.address = member.address;
            tr.dataset.tel = member.tel;
            tr.dataset.paid = member.is_paid;
            tr.dataset.paymentType = member.payment_type || CURRENT_PAYMENT_TYPE;
            tr.dataset.paidMonths = member.paid_months || '[]';

            tr.innerHTML = `
                <td class="col-group">${escapeHTML(member.group_name)}</td>
                <td class="col-person">
                    ${member.position ? `<div class="person-position">${escapeHTML(member.position)}</div>` : ''}
                    <div class="person-name">
                        ${escapeHTML(member.name)}
                        <small class="pc-only">${escapeHTML(member.name_kana)}</small>
                    </div>
                </td>
                <td class="col-address pc-only">${escapeHTML(member.address)}</td>
                <td class="col-phone pc-only">${escapeHTML(member.tel)}</td>
                <td class="col-paid ${paidClass}">${paidText}</td>
                <td class="col-action pc-only" style="white-space: nowrap;">
                    <button type="button" class="jcc-button btn-edit-pc button-primary" style="display: inline-block; margin-right: 5px;">編集</button>
                    <button type="button" class="jcc-button btn-delete-pc button-danger" style="display: inline-block;">削除</button>
                </td>
            `;
            tbody.appendChild(tr);
        });
    };

    const renderPagination = (totalPages, current) => {
        pagContainer.innerHTML = '';
        if (totalPages <= 1) return;

        for (let i = 1; i <= totalPages; i++) {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = `jcc-page-btn ${i === current ? 'active' : ''}`;
            btn.textContent = i;
            btn.addEventListener('click', () => fetchMembers(i));
            pagContainer.appendChild(btn);
        }
    };

    // === 会費方式設定のUI切り替え処理 ===
    const btnEditFeeSetting = document.getElementById('btn-edit-fee-setting');
    const feeSettingForm = document.getElementById('jcc-fee-setting-form');
    const btnCancelFeeSetting = document.getElementById('btn-cancel-fee-setting');

    if (btnEditFeeSetting && feeSettingForm && btnCancelFeeSetting) {
        // 「変更」ボタンクリックでフォームを展開
        btnEditFeeSetting.addEventListener('click', () => {
            console.log('click');
            btnEditFeeSetting.style.display = 'none';
            feeSettingForm.style.display = 'flex';
        });

        // 「キャンセル」ボタンクリックでフォームを閉じ、ラジオボタンの状態を戻す
        btnCancelFeeSetting.addEventListener('click', () => {
            feeSettingForm.style.display = 'none';
            btnEditFeeSetting.style.display = 'inline-flex';

            // ラジオボタンの選択状態を、保存されている CURRENT_PAYMENT_TYPE に戻す
            document.querySelectorAll('input[name="jcc-payment-setting"]').forEach(radio => {
                radio.checked = radio.value === CURRENT_PAYMENT_TYPE;
            });
        });
    }

    // === 会費方式の保存処理 ===
    document.getElementById('btn-save-fee-setting').addEventListener('click', async (e) => {
        const nextType = document.querySelector('input[name="jcc-payment-setting"]:checked')?.value || 'yearly';
        const btn = e.target;

        btn.disabled = true;
        btn.textContent = '保存中...';

        try {
            const response = await fetch(config.apiBaseUrl + 'save-fee-setting', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': config.restNonce
                },
                body: JSON.stringify({ paymentType: nextType })
            });
            const result = await response.json();

            if (!response.ok || !result.success) {
                throw new Error(result.message || '会費設定の保存に失敗しました。');
            }

            const typeLabel = document.getElementById('jcc-current-payment-type-label');
            if (typeLabel) {
                typeLabel.textContent = `${nextType === 'yearly' ? '年会費' : '月会費'}`;
            }

            syncPaymentTypeUI(result.data.payment_type, { clearFilters: true });

            // ★ 保存成功時、フォームを閉じて「変更」ボタンを再表示する
            if (feeSettingForm && btnEditFeeSetting) {
                feeSettingForm.style.display = 'none';
                btnEditFeeSetting.style.display = 'inline-flex';
            }

            await fetchMembers(1);
        } catch (error) {
            alert(error.message || '会費設定の保存に失敗しました。');
        } finally {
            btn.disabled = false;
            btn.textContent = '保存';
        }
    });

    document.getElementById('btn-search').addEventListener('click', () => {
        fetchMembers(1);
        closeFilterModal(); // PC時は guards により何もしない、SP時のみ閉じる
    });

    btnReset?.addEventListener('click', () => {
        document.getElementById('filter-search').value = '';
        document.getElementById('filter-group').value = '';
        document.getElementById('filter-position').value = '';
        document.getElementById('filter-pstatus').value = '';
        document.getElementById('filter-pmonth').value = '';
        document.getElementById('filter-mstatus').value = '';
        document.getElementById('filter-sort').value = 'default';

        syncPaymentTypeUI(CURRENT_PAYMENT_TYPE, { clearFilters: true });
        fetchMembers(1);
    });

    document.getElementById('filter-search').addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            document.getElementById('btn-search').click();
        }
    });

    const memberModal = document.getElementById('jcc-member-modal');
    const viewMode = document.getElementById('jcc-modal-view-mode');
    const editMode = document.getElementById('jcc-modal-edit-mode');
    const title = document.getElementById('jcc-modal-title');

    const updatePaymentFormVisibility = (paymentType) => {
        document.getElementById('edit-yearly-wrap').style.display  = paymentType === 'yearly' ? 'block' : 'none';
        document.getElementById('edit-monthly-wrap').style.display = paymentType === 'monthly' ? 'block' : 'none';
    };

    const openModal = (data, mode) => {
        document.getElementById('edit-id').value = data.id || '';
        memberModal.dataset.paymentType = data.paymentType || CURRENT_PAYMENT_TYPE;
        memberModal.dataset.paid = data.paid || '0';
        memberModal.dataset.paidMonths = data.paidMonths || '[]';

        if (mode === 'view') {
            title.textContent = '会員詳細';
            document.getElementById('view-kana').textContent = data.kana || '';
            document.getElementById('view-group').textContent = data.group || '';
            document.getElementById('view-position').textContent = data.position || '';
            document.getElementById('view-name').textContent = data.name || '';
            document.getElementById('view-address').textContent = data.address || '';
            const phone = document.getElementById('view-phone');
            phone.textContent = data.tel || '';
            phone.href = data.tel ? 'tel:' + data.tel.replace(/-/g,'') : '';

            const viewPaid = document.getElementById('view-paid');
            if ((data.paymentType || CURRENT_PAYMENT_TYPE) === 'monthly') {
                let months = [];
                try { months = JSON.parse(data.paidMonths || '[]'); } catch (e) { months = []; }
                viewPaid.innerHTML = months.length > 0
                    ? `<span style="color:#16a34a; font-weight:bold;">${months.join(', ')}月 済</span>`
                    : '<span style="color:#dc2626; font-weight:bold;">未納</span>';
            } else {
                viewPaid.innerHTML = String(data.paid) === '1'
                    ? '<span style="color:#16a34a; font-weight:bold;">✓ 既納 (年会費)</span>'
                    : '<span style="color:#dc2626; font-weight:bold;">× 未納 (年会費)</span>';
            }

            viewMode.style.display = 'block';
            editMode.style.display = 'none';
        } else {
            title.textContent = data.id ? '会員情報の編集' : '新規会員の追加';
            document.getElementById('edit-group').value = data.group || '';
            document.getElementById('edit-position').value = data.position || '';
            document.getElementById('edit-name').value = data.name || '';
            document.getElementById('edit-kana').value = data.kana || '';
            document.getElementById('edit-address').value = data.address || '';
            document.getElementById('edit-phone').value = data.tel || '';

            const elPaid = document.querySelector(`input[name="edit-is-paid"][value="${data.paid || '0'}"]`);
            if (elPaid) elPaid.checked = true;

            let months = [];
            try { months = JSON.parse(data.paidMonths || '[]'); } catch (e) { months = []; }
            document.querySelectorAll('input[name="edit-paid-months[]"]').forEach(cb => {
                cb.checked = months.includes(parseInt(cb.value, 10));
            });

            viewMode.style.display = 'none';
            editMode.style.display = 'block';
        }

        updatePaymentFormVisibility(data.paymentType || CURRENT_PAYMENT_TYPE);
        memberModal.classList.add('show');
    };

    const closeModal = () => memberModal.classList.remove('show');
    memberModal.querySelector('.jcc-modal-close').addEventListener('click', closeModal);
    memberModal.addEventListener('click', (e) => { if (e.target === memberModal) closeModal(); });

    document.getElementById('btn-open-create').addEventListener('click', () => {
        openModal({
            id: '',
            group: '',
            position: '',
            name: '',
            kana: '',
            address: '',
            tel: '',
            paymentType: CURRENT_PAYMENT_TYPE,
            paid: '0',
            paidMonths: '[]'
        }, 'edit');
    });

    document.getElementById('btn-switch-edit').addEventListener('click', () => {
        openModal({
            id: document.getElementById('edit-id').value,
            group: document.getElementById('view-group').textContent,
            position: document.getElementById('view-position').textContent,
            name: document.getElementById('view-name').textContent,
            kana: document.getElementById('view-kana').textContent,
            address: document.getElementById('view-address').textContent,
            tel: document.getElementById('view-phone').textContent,
            paymentType: memberModal.dataset.paymentType || CURRENT_PAYMENT_TYPE,
            paid: memberModal.dataset.paid || '0',
            paidMonths: memberModal.dataset.paidMonths || '[]'
        }, 'edit');
    });

    tbody.addEventListener('click', (e) => {
        const row = e.target.closest('.jcc-member-row');
        if (!row) return;
        const isPC = window.innerWidth >= 768;

        if (e.target.closest('.btn-delete-pc')) {
            executeDelete(row.dataset.id, row.dataset.name);
            return;
        }
        if (isPC && !e.target.closest('.btn-edit-pc')) return;

        if (e.target.closest('.btn-edit-pc')) {
            openModal(row.dataset, 'edit');
        } else {
            openModal(row.dataset, 'view');
        }
    });

    document.getElementById('btn-delete-mobile').addEventListener('click', () => {
        executeDelete(document.getElementById('edit-id').value, document.getElementById('view-name').textContent);
    });

    const executeDelete = async (id, name) => {
        if (!confirm(`${name} さんを名簿から退会させますか？`)) return;
        try {
            const response = await fetch(config.apiBaseUrl + 'delete-member', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-WP-Nonce': config.restNonce },
                body: JSON.stringify({ id: id })
            });
            const result = await response.json();
            if (response.ok && result.success) {
                closeModal();
                await refreshFilterOptions();
                await fetchMembers(currentPage);
            } else {
                alert(result.message || '削除に失敗しました。');
            }
        } catch (error) {
            alert('通信エラーが発生しました。');
        }
    };

    document.getElementById('btn-save-edit').addEventListener('click', async (e) => {
        const currentId = document.getElementById('edit-id').value;
        const btn = e.target;

        const postData = {
            id: currentId,
            group: document.getElementById('edit-group').value.trim(),
            position: document.getElementById('edit-position').value.trim(),
            name: document.getElementById('edit-name').value.trim(),
            kana: document.getElementById('edit-kana').value.trim(),
            address: document.getElementById('edit-address').value.trim(),
            phone: document.getElementById('edit-phone').value.trim(),
            isPaid: document.querySelector('input[name="edit-is-paid"]:checked')?.value || '0',
            paidMonths: Array.from(document.querySelectorAll('input[name="edit-paid-months[]"]:checked')).map(cb => parseInt(cb.value, 10))
        };

        if (!postData.name) return alert('氏名は必須です。');

        btn.disabled = true;
        btn.textContent = '保存中...';

        const endpoint = currentId
            ? config.apiBaseUrl + 'update-member'
            : config.apiBaseUrl + 'create-member';

        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-WP-Nonce': config.restNonce },
                body: JSON.stringify(postData)
            });
            const result = await response.json();

            if (response.ok && result.success) {
                closeModal();
                await refreshFilterOptions();
                await fetchMembers(currentPage);
            } else {
                alert(result.message || '保存に失敗しました。');
            }
        } catch (error) {
            alert('通信エラーが発生しました。');
        } finally {
            btn.disabled = false;
            btn.textContent = '保存して閉じる';
        }
    });

    const csvModal = document.getElementById('jcc-csv-modal');
    const btnOpenCsv = document.getElementById('btn-open-csv-import');
    const btnCloseCsv = document.getElementById('btn-close-csv');
    const btnExecuteCsv = document.getElementById('btn-execute-csv-import');
    const csvInput = document.getElementById('csv-file-input');
    const csvMsg = document.getElementById('csv-import-message');

    if (btnOpenCsv && csvModal) {
        btnOpenCsv.addEventListener('click', () => {
            csvInput.value = '';
            csvMsg.textContent = '';
            csvMsg.style.color = '#dc2626';
            csvModal.classList.add('show');
        });

        const closeCsvModal = () => csvModal.classList.remove('show');
        btnCloseCsv.addEventListener('click', closeCsvModal);
        csvModal.addEventListener('click', (e) => { if(e.target === csvModal) closeCsvModal(); });

        btnExecuteCsv.addEventListener('click', async () => {
            if (!csvInput.files || csvInput.files.length === 0) {
                csvMsg.textContent = 'CSVファイルを選択してください。';
                return;
            }

            const file = csvInput.files[0];
            if (!file.name.toLowerCase().endsWith('.csv')) {
                csvMsg.textContent = 'CSV形式のファイルを選択してください。';
                return;
            }

            btnExecuteCsv.disabled = true;
            btnExecuteCsv.textContent = '登録中...';
            csvMsg.textContent = 'アップロード・登録処理中です。画面を閉じないでください...';
            csvMsg.style.color = '#004982';

            const formData = new FormData();
            formData.append('csv_file', file);

            try {
                const response = await fetch(config.apiBaseUrl + 'import-members-csv', {
                    method: 'POST',
                    headers: { 'X-WP-Nonce': config.restNonce },
                    body: formData
                });
                const result = await response.json();

                if (response.ok && result.success) {
                    alert(result.message);
                    closeCsvModal();
                    await refreshFilterOptions();
                    await fetchMembers(currentPage);
                } else {
                    csvMsg.style.color = '#dc2626';
                    csvMsg.textContent = result.message || 'エラーが発生しました。';
                }
            } catch (error) {
                csvMsg.style.color = '#dc2626';
                csvMsg.textContent = '通信エラーが発生しました。';
            } finally {
                btnExecuteCsv.disabled = false;
                btnExecuteCsv.textContent = '一括登録を実行';
            }
        });
    }

    // === 印刷機能の追加（別タブ展開・PHP出力版） ===
    const btnPrint = document.getElementById('btn-print-table');
    if (btnPrint) {
        btnPrint.addEventListener('click', () => {
            // 現在の絞り込み条件をURLパラメータとしてまとめる
            const params = new URLSearchParams({
                jcc_action: 'print_members', // ★PHP側で印刷ページを出力させるためのトリガー
                search: document.getElementById('filter-search').value,
                group: document.getElementById('filter-group').value,
                position: document.getElementById('filter-position').value,
                ptype: CURRENT_PAYMENT_TYPE,
                pstatus: CURRENT_PAYMENT_TYPE === 'yearly'
                    ? document.getElementById('filter-pstatus').value
                    : document.getElementById('filter-mstatus').value,
                pmonth: CURRENT_PAYMENT_TYPE === 'monthly'
                    ? document.getElementById('filter-pmonth').value
                    : '',
                sort: document.getElementById('filter-sort').value
            });

            // 現在のURLにパラメータを付与して新しいタブ（_blank）で開く
            const currentUrl = window.location.href.split('?')[0];
            window.open(currentUrl + '?' + params.toString(), '_blank');
        });
    }

    // 既存の処理
    syncPaymentTypeUI(CURRENT_PAYMENT_TYPE, { clearFilters: true });
    fetchMembers(1);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMemberControl);
} else {
    initMemberControl();
}